import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from '../../../../modal/Settings/Production_Management/Margin_Capital/AddMarginCapital';
import Edit from '../../../../modal/Settings/Production_Management/Margin_Capital/EditMarginCapital';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const order_type = [
  { value: "0", label: "Subscription Order" },
  { value: "1", label: "Catering Order" },
  { value: "2", label: "Corporate Order" },
];

const getOrderTypeLabel = (value) => {
  const valStr = value?.toString();
  const found = order_type.find((item) => item.value === valStr);
  return found ? found.label : "Unknown";
};

const MaginCapital = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const tableRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [selectedEditItem, setSelectedEditItem] = useState(null);

  const [marginCapitalList, setMarginCapitalList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [perPage, setPerPage] = useState(25);
  const [totalEntries, setTotalEntries] = useState(0); // ✅ Fixed typo here

  const handleModalToggle = () => {
    setModalType("Add");
    setOpen(true);
  };

  const handleModalToggle_Edit = () => {
    setModalType("Edit");
    setOpen(true);
  };

  const fetchMarginCapitalData = async () => {
    try {
      const response = await axios.get(`${baseURL}/margincapital/list`);
      setMarginCapitalList(response.data);
      setFilteredData(response.data);
    } catch (error) {
      console.error("Failed to fetch margin capital data:", error);
    }
  };

    const handleStatusToggle = async (item) => {
        const newStatus = item.status === 1 ? 0 : 1;

        try {
            const response = await axios.put(`${baseURL}/margincapital/update_status/${item.sno}`, {
            status: newStatus
            });

            if (response.data.success) {
            toast.success(response.data.message || "Status updated successfully!");
            fetchMarginCapitalData(); // Refresh the list
            } else {
            toast.error(response.data.message || "Failed to update status.");
            }
        } catch (error) {
            console.error("Error updating status:", error);
            toast.error("Something went wrong while updating status.");
        }
    };



  useEffect(() => {
    fetchMarginCapitalData();
  }, []);

  useEffect(() => {
    const filtered = marginCapitalList.filter(item =>
      item.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.margin_capital?.toString().includes(searchTerm) ||
      getOrderTypeLabel(item.order_type)?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setTotalEntries(filtered.length);
    setTotalPages(Math.ceil(filtered.length / perPage));

    const start = (page - 1) * perPage;
    const end = start + perPage;
    setFilteredData(filtered.slice(start, end));
  }, [searchTerm, page, perPage, marginCapitalList]);

    const DeleteModal = (item) => {
    swal.fire({
        html: `<div class="alert alert-danger">You're about to lose one Margin Capital</div>`,
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        customClass: {
        cancelButton: 'btn btn-sm btn-secondary',
        confirmButton: 'btn btn-sm btn-danger',
        },
    }).then(async (result) => {
        if (result.isConfirmed) {
        try {
            await axios.delete(`${baseURL}/margincapital/margin_delete/${item.sno}`);

            // Update your state here - example:
            setMarginCapitalList(prev => prev.filter(m => m.sno !== item.sno));
            setFilteredData(prev => prev.filter(m => m.sno !== item.sno));

            toast.success('Deleted successfully!');
        } catch (error) {
            console.error('Delete error:', error);
            toast.error('Failed to delete.');
        }
        }
    });
    };


  useEffect(() => {
    if (tableRef.current && !$.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable({
        responsive: true,
        ordering: false,
        language: { lengthMenu: "Show _MENU_" },
        dom:
          "<'row'" +
          "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
          "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
          ">" +
          "<'table-responsive'tr>" +
          "<'row'" +
          "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
          "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
          ">"
      });
    }
  }, []);

  return (
    <>
      {/* Header and Breadcrumbs */}
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
        <div>
          <h4 className='breadcrumb-header'>Margin Capital</h4>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item"><Link to='/settings'>Settings</Link></li>
            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active">Production Management</li>
          </ol>
        </div>
        <Button className="btn btn-primary btn-sm" onClick={handleModalToggle}>
          <i className="fa-solid fa-plus me-2 fs-8"></i>Add Margin Capital
        </Button>
        {open && modalType === "Add" && <Add show={open} onClose={() => setOpen(false)} />}
        {open && modalType === "Edit" && (
          <Edit
            show={open}
            onClose={() => setOpen(false)}
            editData={selectedEditItem}
            onUpdated={fetchMarginCapitalData}
          />
        )}
      </div>

      {/* Table Controls */}
      <div className="table-container">
         <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{  fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); 
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{  fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>


        {/* Data Table */}
        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
          <thead>
            <tr className="text-start fw-bold fs-6 gs-0 th_head">
              <th>S.No</th>
              <th className='text-center'>Margin Capital</th>
              <th>Order Type</th>
              <th>Description</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 fw-semibold fs-7">
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center">No data available</td>
              </tr>
            ) : (
              filteredData.map((item, index) => (
                <tr key={item.id || index}>
                  <td className='text-start'><label className='text-black font-w400 fs-7'>{(page - 1) * perPage + index + 1} </label></td>
                  <td className="text-center"><label className='text-black font-w400 fs-7'>{item.margin_capital}%</label></td>
                  <td><label className='text-black font-w400 fs-7'>{getOrderTypeLabel(item.order_type)}</label></td>
                  <td>
                    <OverlayTrigger
                      trigger="hover"
                      placement="bottom"
                      overlay={
                        <Tooltip className='toltip-popover'>
                          <span className='fs-8 text-white fw-semibold'>{item.description}</span>
                        </Tooltip>
                      }>
                      <div className='text-truncate mw-100px  text-black font-w400 fs-7'>{item.description}</div>
                    </OverlayTrigger>
                  </td>
                  <td>
                    <div className="form-check form-switch d-flex align-items-center mb-3">
                     <input
                        className="form-check-input me-2"
                        type="checkbox"
                        role="switch"
                        defaultChecked={item.status === 0}
                        onChange={() => handleStatusToggle(item)}
                        />
                    </div>
                  </td>
                  <td>
                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip>Edit</Tooltip>}>
                      <Button
                        variant="primary tp-btn-light px-2 py-1 me-1"
                        onClick={() => {
                          setModalType("Edit");
                          setOpen(true);
                          setSelectedEditItem(item);
                        }}>
                        <i className="fa-solid fa-pen-to-square fs-6"></i>
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip>Delete</Tooltip>}>
                      <Button
                        variant="primary tp-btn-light px-2 py-1 me-1"
                        onClick={() => DeleteModal(item)}>
                        <i className="fa-solid fa-trash-can fs-6"></i>
                      </Button>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Pagination Footer */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>
            {filteredData.length > 0 ? (
              <span className="text-muted">
                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + filteredData.length} of {totalEntries} entries
              </span>
            ) : (
              <span className="text-muted">Showing 0 to 0 of 0 entries</span>
            )}
          </div>

          <nav>
            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
              <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setPage(page - 1)}>Previous</button>
              </li>

              {[...Array(totalPages)].map((_, i) => (
                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                  <button className="page-link" onClick={() => setPage(i + 1)}>{i + 1}</button>
                </li>
              ))}

              <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default MaginCapital;
